import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseRegenerateAgentOfficeApiMutationProps = {
	onSuccess?: Function;
	onError?: Function;
};

const useRegenerateAgentOfficeApiMutation = ({
	onSuccess,
	onError,
}: UseRegenerateAgentOfficeApiMutationProps = {}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ companyId }: { companyId: string }) => {
			return agentOfficeSetupService.regenerateAgentOfficeApi({
				companyId,
			});
		},
		{
			onSuccess(result) {
				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);

				onError?.(error);
			},
		},
	);
};

export default useRegenerateAgentOfficeApiMutation;
